import React, { useEffect, useState } from 'react'
import { Statistic } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { BackButton, BasicSettingWrapper, CustomSettingWrapper, BasicInfoWrapper, SettingWrapper, SubTitle, CriteriaInfo, CriteriaInfoTitle, MapWrapper } from '../segment.styled'
import dayjs from 'dayjs'
import { basicConf, categoryConf } from './config/srcConf'
import { operator } from './config/fixedConf'
import { Sources } from '../../../constants/Sources'
import { MapContainer, TileLayer } from 'react-leaflet'
import MapMarker from './MapMarker'
import { fetchLocationByIds } from '../../../apis/location'

function CriteriaDetail (props) {
  const { goBackPath, modalMode, modalData } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location || {}
  const { data } = state || {}
  const { name, dataSourceType, status, createdAt, updatedAt, creator, rule, UISetting } = (modalMode ? modalData : data) || {}
  const conf = categoryConf(ln_t)[dataSourceType?.name]?.options || []
  const opConf = operator(ln_t)
  const { useCustomComponent } = basicConf[dataSourceType?.name] || {}

  const customComponent = { [Sources.LOCATION]: <LocationDetail {...props} /> }

  const goBack = () => navigate(goBackPath)

  useEffect(() => { if (!data && !modalData) return goBack() }, [])

  const formatDate = (date, detail) => dayjs(date).format(detail ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')
  const ruleComponent = useCustomComponent
    ? customComponent[dataSourceType?.name]
    : UISetting?.map((item, idx) => {
      const { category, siteName, period, indic, setting } = item
      const { col, func, val } = indic || {}
      const selectedCat = conf?.find(i => i.value === category)
      const { label: catName, aggregateOptions, logicOptions } = selectedCat || {}
      return <CriteriaInfo key={idx} modalMode={modalMode}>
        <CriteriaInfoTitle>
          {idx !== 0 ? <div>{ln_t(`criteria.${rule?.logic?.toLowerCase()}`)}</div> : ''}
          {catName ? <div>{catName}</div> : ''}
          {siteName ? <div>{siteName}</div> : ''}
          <div>{ln_t('criteria.forPastFew')} {period} {ln_t('criteria.days')}</div>
        </CriteriaInfoTitle>

        {indic
          ? <div style={{ color: 'var(--primary)', fontWeight: 500 }}>
              {func} {aggregateOptions?.find(i => i.value === col)?.label} - {ln_t('criteria.top')} {val}%
            </div>
          : ''}

        {setting?.map((set, index) => {
          const { col, isTotal, operator, val, name } = set || {}
          const colLabel = logicOptions?.find(i => i.value === `${col}${isTotal ? `-${isTotal}` : ''}`)?.label
          const opLabel = colLabel ? opConf[operator]?.label?.toLowerCase() : opConf[operator]?.label
          return <div key={index}>{colLabel} {opLabel} {name || val}</div>
        })}
      </CriteriaInfo>
    })
  return (
    modalMode
      ? ruleComponent
      : <>
        <BackButton>
          <ArrowLeftOutlined onClick={() => goBack()} />
          {ln_t('segment.criteria')} {ln_t('segment.detail')}
        </BackButton>
        <SettingWrapper>
          <BasicSettingWrapper>
            <SubTitle>{ln_t('util.basicInfo')}</SubTitle>
            <BasicInfoWrapper>
              <Statistic title={ln_t('util.name')} value={name || '-'} />
              <Statistic title={ln_t('util.type')} value={dataSourceType?.name || '-'} />
              <Statistic title={ln_t('util.status')} value={status ? ln_t('util.enable') : ln_t('util.disable')} />
              <Statistic title={ln_t('util.creator')} value={creator?.name || '-'} />
              <Statistic title={ln_t('util.createdAt')} value={formatDate(createdAt, true)} />
              <Statistic title={ln_t('util.updatedAt')} value={formatDate(updatedAt, true)} />
            </BasicInfoWrapper>
          </BasicSettingWrapper>
          <CustomSettingWrapper>
            <SubTitle>{ln_t('segment.criteria')} {ln_t('target.detail')}</SubTitle>
            {ruleComponent}
          </CustomSettingWrapper>
        </SettingWrapper>
      </>
  )
}

function LocationDetail (props) {
  const { modalMode, modalData } = props
  const { t: ln_t } = useTranslation()
  const location = useLocation()
  const { state } = location || {}
  const { data } = state || {}
  const [position, setPosition] = useState({ lat: 23.723876, lng: 120.872141 })
  const [selectedLocation, setSelectedLocation] = useState([])
  const { code, points } = modalMode ? modalData?.rule : data?.rule || {}
  const selectedName = selectedLocation?.map(i => i?.name)

  const getLoc = async () => {
    const ids = points?.map(({ id }) => id)?.join(',')
    const res = await fetchLocationByIds(ids)
    setSelectedLocation(res?.data)
  }
  useEffect(() => { getLoc() }, [modalData])

  const capitalized = str => str?.charAt(0)?.toUpperCase() + str?.slice(1)
  return <>
    {selectedLocation?.length
      ? <>
          <BasicInfoWrapper style={{ paddingBottom: '12px', flexDirection: 'row', gap: '48px' }}>
            <Statistic title={ln_t('util.type')} value={capitalized(code || '-')} />
            <Statistic title={ln_t('criteria.location.selectedLocation')} value={selectedName?.join(', ') || '-'} />
          </BasicInfoWrapper>
          <MapWrapper style={{ width: '100%' }}>
            <MapContainer center={position} zoom={7}>
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <MapMarker position={position} setPosition={setPosition} selectedLocation={selectedLocation} />
            </MapContainer>
          </MapWrapper>
        </>
      : ''
    }
  </>
}

export default CriteriaDetail
